import { render, staticRenderFns } from "./ReviewMovementAlert.vue?vue&type=template&id=2ca64afc"
import script from "./ReviewMovementAlert.vue?vue&type=script&lang=js"
export * from "./ReviewMovementAlert.vue?vue&type=script&lang=js"
import style0 from "./ReviewMovementAlert.vue?vue&type=style&index=0&id=2ca64afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports